import { render } from "./ProdutosVendidos.vue?vue&type=template&id=1025cdd6"
import script from "./ProdutosVendidos.vue?vue&type=script&lang=js"
export * from "./ProdutosVendidos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__